<template>
  <div class=" is-fullwidth">
    
    
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          
          <th>Range</th>
          <th>Colourway</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Location</th>
          <th @click="checkAll()" style="cursor:pointer">Export</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="9" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="9" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in orders" v-bind:key="order.orderID">
         
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          
          <td>{{order.range_name}}</td>
          <td></td>
          <td>{{order.deliverydate_export}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.makeup_location_name }}</td>
          <td><input type="checkbox" class="checkbox" v-model="order.checked" value="1"/></td>
          
          
              
			</tr>
    	</tbody>
        <tfoot style="display:none">
            <tr>
                <td colspan="8">&nbsp;</td>
                <td>
                  <button class="button is-success is-small" @click="exportXLS()" v-if="filteredOrders.length > 0 && this.exported == false">Export</button>
                  <button class="button is-danger is-small" @click="refreshPage()" v-if="this.exported == true">Refresh Page</button>
                </td>
            </tr>
        </tfoot>
    </table>

    <table class="table is-hoverable is-fullwidth is-size-7" id="exporttable">
    	<thead>
    		<tr>
        <th>PO Number</th>
   	 		
          <th>Garment</th>
          <th>Colourway</th>
          <th>Delivery</th>
          <th>Size</th>
          <th>Qty</th>
          <th>Location</th>
        </tr>
    	</thead>
        <tbody>
   
    	
		   <template v-for="order in filteredOrders" >
              <tr v-for="row in order.sizes" v-bind:key="row.name">
            
                <td >{{order.ponumber}}</td>
           
            <td>{{order.garmentname}}</td>
            <td>{{order.design_colourway}}</td>
            <td>{{order.deliverydate_export}}</td>
            <td>{{ row.label }}</td>
            <td>{{ row.qty }}</td>
            <td>{{ order.makeup_location_name }}</td>
        </tr>
           </template>
            
        
    	</tbody>
    </table>
   
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      limit: 500,
      sizes: [],
      exported: false
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getPmsExportOrders(this.accessToken, this.limit, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      exportXLS() {
		 //alert("hi")
		var wb = XLSX.utils.table_to_book(document.getElementById('exporttable'), {raw:true});
		 XLSX.writeFile(wb, 'PMS Export.csv', {'bookType': 'csv'})

         // Update database with exported flag
         this.updateExportedOrders()
	 },
   refreshPage() {
      this.exported = false
      this.getOrders()
   },
     updateExportedOrders() {
        this.working = true

        var formdata = { 
            _method: 'patch',
             field_to_set: 'exported_to_pms',
             value: 1,
             order_ids: this.ordersToUpdate
        }; 

        OrderService.updateMultiOrder(this.accessToken, formdata)
        .then(() => {
            
            this.working = false
            this.exported = true

            // Remove the orders from this screen
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
     },
     checkAll()
     {
        for (var i = 0; i < this.orders.length; i++) {
                this.orders[i].checked = true;
                
            }
     }
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) { 
            if(  u.checked == true) 
            {
              return 1
            }
          })
          return filteredOrders
     },
     ordersToUpdate: function () {
        const ordersToUpdate = this.filteredOrders.map( (order) => order.orderID )

        return ordersToUpdate
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getSizes();
           //this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }
      
  },
  watch: {
    makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

